import React from 'react';
import { Button } from '@vp/swan';
import PropTypes from 'prop-types';
import useSiteData from '../../../hooks/useSiteData';
import { trackNavigationClicked } from '../../../apis/trackingApi';

// we need to include the shipping step first, otherwise the query param will be ignored
const FORCE_SIGN_IN_QUERY_PARAM = '#s?forceSignIn=true';

function SignInAndCheckoutButton({ buttonText, disabled, size, mb }) {
  const { externalAppNavigation } = useSiteData();
  const checkoutUrl = `${externalAppNavigation.checkout}${FORCE_SIGN_IN_QUERY_PARAM}`;

  const onClickHandler = () => {
    trackNavigationClicked({
      sourcePagePath: externalAppNavigation.cart,
      destinationPagePath: checkoutUrl,
      ctaValue: 'signInAndCheckout',
    });
  };

  return (
    <Button
      component="a"
      skin="primary"
      width="full-width"
      href={checkoutUrl}
      aria-disabled={disabled}
      size={size}
      marginBottom={mb}
      onClick={onClickHandler}
    >
      {buttonText}
    </Button>
  );
}

SignInAndCheckoutButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  mb: PropTypes.string,
};

export default SignInAndCheckoutButton;
